const _Hub_Name = "taskhub";

const _Invoke_Methods_Names = {
  saveTask: "SaveCRMTask",
  deleteTask: "DeleteCRMTask",
  duplicateTask: "DuplicateCRMTask",
  // task settings

  // ---- tast-statuses
  saveTaskStatus: "SaveTaskStatus",
  deleteTaskStatus: "DeleteTaskStatus",

  // ---- tast-type
  saveTaskType: "SaveTaskType",
  deleteTaskType: "DeleteTaskType",

  // ---- tast-priority
  saveTaskPriority: "SaveTaskPriority",
  deleteTaskPriority: "DeleteTaskPriority",

  reorderTask: "UpdateTaskStatusesOrder",

  SaveTaskComment: "SaveTaskComment",
  deleteTaskComment: "DeleteTaskComment",

  completeTask: "CompleteTask",
};

const _OnReceive_Methods_Names = {
  onSaveTask: "SaveCRMTaskResponse",
  onDeleteTask: "DeleteCRMTaskResponse",
  onDuplicateTask: "DuplicateCRMTaskResponse",
  // task settings
  // ---- tast-statuses
  onSaveTaskStatus: "SaveTaskStatusResponse",
  onDeleteTaskStatus: "DeleteTaskStatusResponse",

  // ---- tast-type
  onSaveTaskType: "SaveTaskTypeResponse",
  onDeleteTaskType: "DeleteTaskTypeResponse",

  // ---- tast-priority
  onSaveTaskPriority: "SaveTaskPriorityResponse",
  onDeleteTaskPriority: "DeleteTaskPriorityResponse",

  // comment
  onSaveTaskComment: "SaveTaskCommentResponse",
  onDeleteTaskComment: "DeleteTaskCommentResponse",

  onCompleteTask: "CompleteTaskResponse",
};

const Task_signalr = {
  hubName: _Hub_Name,
  InvokeMethodNames: _Invoke_Methods_Names,
  onReceiveMethodNames: _OnReceive_Methods_Names,
};

export default Task_signalr;
